import * as ambassadorWixEventsV2Rsvp from './events-v2-rsvp-rsvp-v-2.http.js';
import * as ambassadorWixEventsV2RsvpTypes from './events-v2-rsvp-rsvp-v-2.types.js';
import * as ambassadorWixEventsV2RsvpUniversalTypes from './events-v2-rsvp-rsvp-v-2.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function searchRsvps(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV2RsvpUniversalTypes.SearchRsvpsRequest,
  ambassadorWixEventsV2RsvpTypes.SearchRsvpsRequest,
  ambassadorWixEventsV2RsvpUniversalTypes.SearchRsvpsResponse,
  ambassadorWixEventsV2RsvpTypes.SearchRsvpsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV2Rsvp.searchRsvps(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/rsvps/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryRsvps(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV2RsvpUniversalTypes.QueryRsvpsRequest,
  ambassadorWixEventsV2RsvpTypes.QueryRsvpsRequest,
  ambassadorWixEventsV2RsvpUniversalTypes.QueryRsvpsResponse,
  ambassadorWixEventsV2RsvpTypes.QueryRsvpsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV2Rsvp.queryRsvps(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/rsvps/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countRsvps(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV2RsvpUniversalTypes.CountRsvpsRequest,
  ambassadorWixEventsV2RsvpTypes.CountRsvpsRequest,
  ambassadorWixEventsV2RsvpUniversalTypes.CountRsvpsResponse,
  ambassadorWixEventsV2RsvpTypes.CountRsvpsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV2Rsvp.countRsvps(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/rsvps/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getRsvp(): __PublicMethodMetaInfo<
  'GET',
  { rsvpId: string },
  ambassadorWixEventsV2RsvpUniversalTypes.GetRsvpRequest,
  ambassadorWixEventsV2RsvpTypes.GetRsvpRequest,
  ambassadorWixEventsV2RsvpUniversalTypes.GetRsvpResponse,
  ambassadorWixEventsV2RsvpTypes.GetRsvpResponse
> {
  const payload = { rsvpId: ':rsvpId' } as any;

  const getRequestOptions = ambassadorWixEventsV2Rsvp.getRsvp(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/rsvps/{rsvpId}',
    pathParams: { rsvpId: 'rsvpId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createRsvp(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV2RsvpUniversalTypes.CreateRsvpRequest,
  ambassadorWixEventsV2RsvpTypes.CreateRsvpRequest,
  ambassadorWixEventsV2RsvpUniversalTypes.CreateRsvpResponse,
  ambassadorWixEventsV2RsvpTypes.CreateRsvpResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV2Rsvp.createRsvp(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/rsvps',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateRsvp(): __PublicMethodMetaInfo<
  'PATCH',
  { rsvpId: string },
  ambassadorWixEventsV2RsvpUniversalTypes.UpdateRsvpRequest,
  ambassadorWixEventsV2RsvpTypes.UpdateRsvpRequest,
  ambassadorWixEventsV2RsvpUniversalTypes.UpdateRsvpResponse,
  ambassadorWixEventsV2RsvpTypes.UpdateRsvpResponse
> {
  const payload = { rsvp: { id: ':rsvpId' } } as any;

  const getRequestOptions = ambassadorWixEventsV2Rsvp.updateRsvp(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/rsvps/{rsvp.id}',
    pathParams: { rsvpId: 'rsvpId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteRsvp(): __PublicMethodMetaInfo<
  'DELETE',
  { rsvpId: string },
  ambassadorWixEventsV2RsvpUniversalTypes.DeleteRsvpRequest,
  ambassadorWixEventsV2RsvpTypes.DeleteRsvpRequest,
  ambassadorWixEventsV2RsvpUniversalTypes.DeleteRsvpResponse,
  ambassadorWixEventsV2RsvpTypes.DeleteRsvpResponse
> {
  const payload = { rsvpId: ':rsvpId' } as any;

  const getRequestOptions = ambassadorWixEventsV2Rsvp.deleteRsvp(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v2/rsvps/{rsvpId}',
    pathParams: { rsvpId: 'rsvpId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateRsvps(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixEventsV2RsvpUniversalTypes.BulkUpdateRsvpsRequest,
  ambassadorWixEventsV2RsvpTypes.BulkUpdateRsvpsRequest,
  ambassadorWixEventsV2RsvpUniversalTypes.BulkUpdateRsvpsResponse,
  ambassadorWixEventsV2RsvpTypes.BulkUpdateRsvpsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV2Rsvp.bulkUpdateRsvps(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/bulk/rsvps/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteRsvpsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV2RsvpUniversalTypes.BulkDeleteRsvpsByFilterRequest,
  ambassadorWixEventsV2RsvpTypes.BulkDeleteRsvpsByFilterRequest,
  ambassadorWixEventsV2RsvpUniversalTypes.BulkDeleteRsvpsByFilterResponse,
  ambassadorWixEventsV2RsvpTypes.BulkDeleteRsvpsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV2Rsvp.bulkDeleteRsvpsByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/rsvps/delete-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function checkInRsvpGuests(): __PublicMethodMetaInfo<
  'POST',
  { rsvpId: string },
  ambassadorWixEventsV2RsvpUniversalTypes.CheckInRsvpGuestsRequest,
  ambassadorWixEventsV2RsvpTypes.CheckInRsvpGuestsRequest,
  ambassadorWixEventsV2RsvpUniversalTypes.CheckInRsvpGuestsResponse,
  ambassadorWixEventsV2RsvpTypes.CheckInRsvpGuestsResponse
> {
  const payload = { rsvpId: ':rsvpId' } as any;

  const getRequestOptions =
    ambassadorWixEventsV2Rsvp.checkInRsvpGuests(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/rsvps/{rsvpId}/check-in',
    pathParams: { rsvpId: 'rsvpId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelRsvpGuestsCheckIn(): __PublicMethodMetaInfo<
  'POST',
  { rsvpId: string },
  ambassadorWixEventsV2RsvpUniversalTypes.CancelRsvpGuestsCheckInRequest,
  ambassadorWixEventsV2RsvpTypes.CancelRsvpGuestsCheckInRequest,
  ambassadorWixEventsV2RsvpUniversalTypes.CancelRsvpGuestsCheckInResponse,
  ambassadorWixEventsV2RsvpTypes.CancelRsvpGuestsCheckInResponse
> {
  const payload = { rsvpId: ':rsvpId' } as any;

  const getRequestOptions =
    ambassadorWixEventsV2Rsvp.cancelRsvpGuestsCheckIn(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/rsvps/{rsvpId}/cancel-check-in',
    pathParams: { rsvpId: 'rsvpId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listRsvpSummary(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEventsV2RsvpUniversalTypes.ListRsvpSummaryRequest,
  ambassadorWixEventsV2RsvpTypes.ListRsvpSummaryRequest,
  ambassadorWixEventsV2RsvpUniversalTypes.ListRsvpSummaryResponse,
  ambassadorWixEventsV2RsvpTypes.ListRsvpSummaryResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV2Rsvp.listRsvpSummary(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/rsvps/summaries',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listCurrentRsvps(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEventsV2RsvpUniversalTypes.ListCurrentRsvpsRequest,
  ambassadorWixEventsV2RsvpTypes.ListCurrentRsvpsRequest,
  ambassadorWixEventsV2RsvpUniversalTypes.ListCurrentRsvpsResponse,
  ambassadorWixEventsV2RsvpTypes.ListCurrentRsvpsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV2Rsvp.listCurrentRsvps(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/rsvps/current',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Rsvp as RsvpOriginal,
  FormResponse as FormResponseOriginal,
  InputValue as InputValueOriginal,
  FormattedAddress as FormattedAddressOriginal,
  CommonAddress as CommonAddressOriginal,
  CommonAddressStreetOneOf as CommonAddressStreetOneOfOriginal,
  CommonStreetAddress as CommonStreetAddressOriginal,
  CommonAddressLocation as CommonAddressLocationOriginal,
  CommonSubdivision as CommonSubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  StandardDetails as StandardDetailsOriginal,
  RsvpStatus as RsvpStatusOriginal,
  RsvpStatusWithLiterals as RsvpStatusWithLiteralsOriginal,
  GuestList as GuestListOriginal,
  Guest as GuestOriginal,
  CheckInDetails as CheckInDetailsOriginal,
  AdditionalGuestDetails as AdditionalGuestDetailsOriginal,
  AdditionalGuest as AdditionalGuestOriginal,
  OnlineConferencingLogin as OnlineConferencingLoginOriginal,
  FormSubmission as FormSubmissionOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  LimitedRsvpSpotsReleased as LimitedRsvpSpotsReleasedOriginal,
  RsvpsBalanceUpdated as RsvpsBalanceUpdatedOriginal,
  V2RsvpSummary as V2RsvpSummaryOriginal,
  RsvpBalanceDelta as RsvpBalanceDeltaOriginal,
  SearchRsvpsRequest as SearchRsvpsRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  Interval as IntervalOriginal,
  IntervalWithLiterals as IntervalWithLiteralsOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  SearchRsvpsResponse as SearchRsvpsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  SearchRsvpsWithOffsetRequest as SearchRsvpsWithOffsetRequestOriginal,
  Search as SearchOriginal,
  SearchPagingMethodOneOf as SearchPagingMethodOneOfOriginal,
  Paging as PagingOriginal,
  SearchRsvpsWithOffsetResponse as SearchRsvpsWithOffsetResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  ListRsvpsRequest as ListRsvpsRequestOriginal,
  LargeCursorPaging as LargeCursorPagingOriginal,
  ListRsvpsResponse as ListRsvpsResponseOriginal,
  QueryRsvpsRequest as QueryRsvpsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  QueryRsvpsResponse as QueryRsvpsResponseOriginal,
  CountRsvpsRequest as CountRsvpsRequestOriginal,
  CountRsvpsResponse as CountRsvpsResponseOriginal,
  GetRsvpRequest as GetRsvpRequestOriginal,
  GetRsvpResponse as GetRsvpResponseOriginal,
  CreateRsvpRequest as CreateRsvpRequestOriginal,
  ModificationOptions as ModificationOptionsOriginal,
  CreateRsvpResponse as CreateRsvpResponseOriginal,
  CalendarLinks as CalendarLinksOriginal,
  GuestLimitExceededData as GuestLimitExceededDataOriginal,
  UpdateRsvpRequest as UpdateRsvpRequestOriginal,
  UpdateRsvpResponse as UpdateRsvpResponseOriginal,
  DeleteRsvpRequest as DeleteRsvpRequestOriginal,
  DeleteRsvpResponse as DeleteRsvpResponseOriginal,
  BulkUpdateRsvpsRequest as BulkUpdateRsvpsRequestOriginal,
  MaskedRsvp as MaskedRsvpOriginal,
  BulkUpdateRsvpsResponse as BulkUpdateRsvpsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkRsvpResult as BulkRsvpResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkDeleteRsvpsByFilterRequest as BulkDeleteRsvpsByFilterRequestOriginal,
  BulkDeleteRsvpsByFilterResponse as BulkDeleteRsvpsByFilterResponseOriginal,
  CheckInRsvpGuestsRequest as CheckInRsvpGuestsRequestOriginal,
  CheckInRsvpGuestsResponse as CheckInRsvpGuestsResponseOriginal,
  CancelRsvpGuestsCheckInRequest as CancelRsvpGuestsCheckInRequestOriginal,
  CancelRsvpGuestsCheckInResponse as CancelRsvpGuestsCheckInResponseOriginal,
  ListRsvpSummaryRequest as ListRsvpSummaryRequestOriginal,
  ListRsvpSummaryResponse as ListRsvpSummaryResponseOriginal,
  ListCurrentRsvpsRequest as ListCurrentRsvpsRequestOriginal,
  ListCurrentRsvpsResponse as ListCurrentRsvpsResponseOriginal,
  EventCreated as EventCreatedOriginal,
  Location as LocationOriginal,
  MapCoordinates as MapCoordinatesOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  ScheduleConfig as ScheduleConfigOriginal,
  Recurrences as RecurrencesOriginal,
  Occurrence as OccurrenceOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  EventStatus as EventStatusOriginal,
  EventStatusWithLiterals as EventStatusWithLiteralsOriginal,
  Event as EventOriginal,
  Scheduling as SchedulingOriginal,
  Image as ImageOriginal,
  Registration as RegistrationOriginal,
  EventType as EventTypeOriginal,
  EventTypeWithLiterals as EventTypeWithLiteralsOriginal,
  RegistrationStatus as RegistrationStatusOriginal,
  RegistrationStatusWithLiterals as RegistrationStatusWithLiteralsOriginal,
  RsvpCollection as RsvpCollectionOriginal,
  RsvpCollectionConfig as RsvpCollectionConfigOriginal,
  RsvpStatusOptions as RsvpStatusOptionsOriginal,
  RsvpStatusOptionsWithLiterals as RsvpStatusOptionsWithLiteralsOriginal,
  RsvpConfirmationMessages as RsvpConfirmationMessagesOriginal,
  RsvpConfirmationMessagesPositiveResponseConfirmation as RsvpConfirmationMessagesPositiveResponseConfirmationOriginal,
  RsvpConfirmationMessagesNegativeResponseConfirmation as RsvpConfirmationMessagesNegativeResponseConfirmationOriginal,
  Ticketing as TicketingOriginal,
  TicketingConfig as TicketingConfigOriginal,
  TaxConfig as TaxConfigOriginal,
  TaxType as TaxTypeOriginal,
  TaxTypeWithLiterals as TaxTypeWithLiteralsOriginal,
  TicketsConfirmationMessages as TicketsConfirmationMessagesOriginal,
  CheckoutType as CheckoutTypeOriginal,
  CheckoutTypeWithLiterals as CheckoutTypeWithLiteralsOriginal,
  Money as MoneyOriginal,
  ExternalEvent as ExternalEventOriginal,
  VisitorType as VisitorTypeOriginal,
  VisitorTypeWithLiterals as VisitorTypeWithLiteralsOriginal,
  SiteUrl as SiteUrlOriginal,
  Form as FormOriginal,
  InputControl as InputControlOriginal,
  InputControlType as InputControlTypeOriginal,
  InputControlTypeWithLiterals as InputControlTypeWithLiteralsOriginal,
  Input as InputOriginal,
  ValueType as ValueTypeOriginal,
  ValueTypeWithLiterals as ValueTypeWithLiteralsOriginal,
  OptionSelection as OptionSelectionOriginal,
  OptionSelectionSelectedOptionOneOf as OptionSelectionSelectedOptionOneOfOriginal,
  Label as LabelOriginal,
  FormMessages as FormMessagesOriginal,
  RsvpFormMessages as RsvpFormMessagesOriginal,
  PositiveResponseConfirmation as PositiveResponseConfirmationOriginal,
  NegativeResponseConfirmation as NegativeResponseConfirmationOriginal,
  Positive as PositiveOriginal,
  Negative as NegativeOriginal,
  CheckoutFormMessages as CheckoutFormMessagesOriginal,
  ResponseConfirmation as ResponseConfirmationOriginal,
  RegistrationClosedMessages as RegistrationClosedMessagesOriginal,
  TicketsUnavailableMessages as TicketsUnavailableMessagesOriginal,
  Dashboard as DashboardOriginal,
  RsvpSummary as RsvpSummaryOriginal,
  TicketingSummary as TicketingSummaryOriginal,
  GuestListConfig as GuestListConfigOriginal,
  Feed as FeedOriginal,
  OnlineConferencing as OnlineConferencingOriginal,
  OnlineConferencingConfig as OnlineConferencingConfigOriginal,
  ConferenceType as ConferenceTypeOriginal,
  ConferenceTypeWithLiterals as ConferenceTypeWithLiteralsOriginal,
  OnlineConferencingSession as OnlineConferencingSessionOriginal,
  SeoSettings as SeoSettingsOriginal,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  Agenda as AgendaOriginal,
  Category as CategoryOriginal,
  CategoryCounts as CategoryCountsOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  EventDisplaySettings as EventDisplaySettingsOriginal,
  LabellingSettings as LabellingSettingsOriginal,
  RichContent as RichContentOriginal,
  Node as NodeOriginal,
  NodeDataOneOf as NodeDataOneOfOriginal,
  NodeType as NodeTypeOriginal,
  NodeTypeWithLiterals as NodeTypeWithLiteralsOriginal,
  NodeStyle as NodeStyleOriginal,
  ButtonData as ButtonDataOriginal,
  BackgroundType as BackgroundTypeOriginal,
  BackgroundTypeWithLiterals as BackgroundTypeWithLiteralsOriginal,
  Gradient as GradientOriginal,
  GradientType as GradientTypeOriginal,
  GradientTypeWithLiterals as GradientTypeWithLiteralsOriginal,
  Stop as StopOriginal,
  Border as BorderOriginal,
  Colors as ColorsOriginal,
  Background as BackgroundOriginal,
  PluginContainerData as PluginContainerDataOriginal,
  WidthType as WidthTypeOriginal,
  WidthTypeWithLiterals as WidthTypeWithLiteralsOriginal,
  PluginContainerDataWidth as PluginContainerDataWidthOriginal,
  PluginContainerDataWidthDataOneOf as PluginContainerDataWidthDataOneOfOriginal,
  PluginContainerDataAlignment as PluginContainerDataAlignmentOriginal,
  PluginContainerDataAlignmentWithLiterals as PluginContainerDataAlignmentWithLiteralsOriginal,
  Spoiler as SpoilerOriginal,
  Height as HeightOriginal,
  ButtonDataType as ButtonDataTypeOriginal,
  ButtonDataTypeWithLiterals as ButtonDataTypeWithLiteralsOriginal,
  Styles as StylesOriginal,
  Link as LinkOriginal,
  LinkDataOneOf as LinkDataOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  Rel as RelOriginal,
  CodeBlockData as CodeBlockDataOriginal,
  TextStyle as TextStyleOriginal,
  TextAlignment as TextAlignmentOriginal,
  TextAlignmentWithLiterals as TextAlignmentWithLiteralsOriginal,
  DividerData as DividerDataOriginal,
  LineStyle as LineStyleOriginal,
  LineStyleWithLiterals as LineStyleWithLiteralsOriginal,
  Width as WidthOriginal,
  WidthWithLiterals as WidthWithLiteralsOriginal,
  DividerDataAlignment as DividerDataAlignmentOriginal,
  DividerDataAlignmentWithLiterals as DividerDataAlignmentWithLiteralsOriginal,
  FileData as FileDataOriginal,
  ViewMode as ViewModeOriginal,
  ViewModeWithLiterals as ViewModeWithLiteralsOriginal,
  FileSource as FileSourceOriginal,
  FileSourceDataOneOf as FileSourceDataOneOfOriginal,
  PDFSettings as PDFSettingsOriginal,
  GalleryData as GalleryDataOriginal,
  Media as MediaOriginal,
  ItemImage as ItemImageOriginal,
  Video as VideoOriginal,
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  GalleryOptions as GalleryOptionsOriginal,
  LayoutType as LayoutTypeOriginal,
  LayoutTypeWithLiterals as LayoutTypeWithLiteralsOriginal,
  Orientation as OrientationOriginal,
  OrientationWithLiterals as OrientationWithLiteralsOriginal,
  Crop as CropOriginal,
  CropWithLiterals as CropWithLiteralsOriginal,
  ThumbnailsAlignment as ThumbnailsAlignmentOriginal,
  ThumbnailsAlignmentWithLiterals as ThumbnailsAlignmentWithLiteralsOriginal,
  GalleryOptionsLayout as GalleryOptionsLayoutOriginal,
  ItemStyle as ItemStyleOriginal,
  Thumbnails as ThumbnailsOriginal,
  GIFData as GIFDataOriginal,
  GIF as GIFOriginal,
  GIFType as GIFTypeOriginal,
  GIFTypeWithLiterals as GIFTypeWithLiteralsOriginal,
  HeadingData as HeadingDataOriginal,
  HTMLData as HTMLDataOriginal,
  HTMLDataDataOneOf as HTMLDataDataOneOfOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  ImageData as ImageDataOriginal,
  StylesBorder as StylesBorderOriginal,
  ImageDataStyles as ImageDataStylesOriginal,
  LinkPreviewData as LinkPreviewDataOriginal,
  StylesPosition as StylesPositionOriginal,
  StylesPositionWithLiterals as StylesPositionWithLiteralsOriginal,
  LinkPreviewDataStyles as LinkPreviewDataStylesOriginal,
  MapData as MapDataOriginal,
  MapSettings as MapSettingsOriginal,
  MapType as MapTypeOriginal,
  MapTypeWithLiterals as MapTypeWithLiteralsOriginal,
  ParagraphData as ParagraphDataOriginal,
  PollData as PollDataOriginal,
  ViewRole as ViewRoleOriginal,
  ViewRoleWithLiterals as ViewRoleWithLiteralsOriginal,
  VoteRole as VoteRoleOriginal,
  VoteRoleWithLiterals as VoteRoleWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  Option as OptionOriginal,
  PollSettings as PollSettingsOriginal,
  PollLayoutType as PollLayoutTypeOriginal,
  PollLayoutTypeWithLiterals as PollLayoutTypeWithLiteralsOriginal,
  PollLayoutDirection as PollLayoutDirectionOriginal,
  PollLayoutDirectionWithLiterals as PollLayoutDirectionWithLiteralsOriginal,
  PollLayout as PollLayoutOriginal,
  OptionLayout as OptionLayoutOriginal,
  PollDesignBackgroundType as PollDesignBackgroundTypeOriginal,
  PollDesignBackgroundTypeWithLiterals as PollDesignBackgroundTypeWithLiteralsOriginal,
  BackgroundGradient as BackgroundGradientOriginal,
  PollDesignBackground as PollDesignBackgroundOriginal,
  PollDesignBackgroundBackgroundOneOf as PollDesignBackgroundBackgroundOneOfOriginal,
  PollDesign as PollDesignOriginal,
  OptionDesign as OptionDesignOriginal,
  Poll as PollOriginal,
  PollDataLayout as PollDataLayoutOriginal,
  Design as DesignOriginal,
  TextData as TextDataOriginal,
  Decoration as DecorationOriginal,
  DecorationDataOneOf as DecorationDataOneOfOriginal,
  DecorationType as DecorationTypeOriginal,
  DecorationTypeWithLiterals as DecorationTypeWithLiteralsOriginal,
  AnchorData as AnchorDataOriginal,
  ColorData as ColorDataOriginal,
  LinkData as LinkDataOriginal,
  MentionData as MentionDataOriginal,
  FontSizeData as FontSizeDataOriginal,
  FontType as FontTypeOriginal,
  FontTypeWithLiterals as FontTypeWithLiteralsOriginal,
  SpoilerData as SpoilerDataOriginal,
  FontFamilyData as FontFamilyDataOriginal,
  AppEmbedData as AppEmbedDataOriginal,
  AppEmbedDataAppDataOneOf as AppEmbedDataAppDataOneOfOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  AspectRatio as AspectRatioOriginal,
  AspectRatioWithLiterals as AspectRatioWithLiteralsOriginal,
  Resizing as ResizingOriginal,
  ResizingWithLiterals as ResizingWithLiteralsOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  CardStylesType as CardStylesTypeOriginal,
  CardStylesTypeWithLiterals as CardStylesTypeWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  Layout as LayoutOriginal,
  LayoutWithLiterals as LayoutWithLiteralsOriginal,
  AppType as AppTypeOriginal,
  AppTypeWithLiterals as AppTypeWithLiteralsOriginal,
  BookingData as BookingDataOriginal,
  EventData as EventDataOriginal,
  ButtonStyles as ButtonStylesOriginal,
  ImageStyles as ImageStylesOriginal,
  RibbonStyles as RibbonStylesOriginal,
  CardStyles as CardStylesOriginal,
  PricingData as PricingDataOriginal,
  VideoData as VideoDataOriginal,
  PlaybackOptions as PlaybackOptionsOriginal,
  EmbedData as EmbedDataOriginal,
  Oembed as OembedOriginal,
  CollapsibleListData as CollapsibleListDataOriginal,
  InitialExpandedItems as InitialExpandedItemsOriginal,
  InitialExpandedItemsWithLiterals as InitialExpandedItemsWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  TableData as TableDataOriginal,
  Dimensions as DimensionsOriginal,
  TableCellData as TableCellDataOriginal,
  VerticalAlignment as VerticalAlignmentOriginal,
  VerticalAlignmentWithLiterals as VerticalAlignmentWithLiteralsOriginal,
  CellStyle as CellStyleOriginal,
  BorderColors as BorderColorsOriginal,
  BorderWidths as BorderWidthsOriginal,
  NullValue as NullValueOriginal,
  NullValueWithLiterals as NullValueWithLiteralsOriginal,
  ListValue as ListValueOriginal,
  AudioData as AudioDataOriginal,
  OrderedListData as OrderedListDataOriginal,
  BulletedListData as BulletedListDataOriginal,
  BlockquoteData as BlockquoteDataOriginal,
  CaptionData as CaptionDataOriginal,
  LayoutData as LayoutDataOriginal,
  ImageScalingScaling as ImageScalingScalingOriginal,
  ImageScalingScalingWithLiterals as ImageScalingScalingWithLiteralsOriginal,
  ImagePosition as ImagePositionOriginal,
  ImagePositionWithLiterals as ImagePositionWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  LayoutDataBackgroundType as LayoutDataBackgroundTypeOriginal,
  LayoutDataBackgroundTypeWithLiterals as LayoutDataBackgroundTypeWithLiteralsOriginal,
  BackdropType as BackdropTypeOriginal,
  BackdropTypeWithLiterals as BackdropTypeWithLiteralsOriginal,
  LayoutDataBackgroundImage as LayoutDataBackgroundImageOriginal,
  VerticalAlignmentAlignment as VerticalAlignmentAlignmentOriginal,
  VerticalAlignmentAlignmentWithLiterals as VerticalAlignmentAlignmentWithLiteralsOriginal,
  ResponsivenessBehaviour as ResponsivenessBehaviourOriginal,
  ResponsivenessBehaviourWithLiterals as ResponsivenessBehaviourWithLiteralsOriginal,
  DesignTarget as DesignTargetOriginal,
  DesignTargetWithLiterals as DesignTargetWithLiteralsOriginal,
  Banner as BannerOriginal,
  LayoutDataBackground as LayoutDataBackgroundOriginal,
  Backdrop as BackdropOriginal,
  LayoutCellData as LayoutCellDataOriginal,
  ShapeData as ShapeDataOriginal,
  ShapeDataStyles as ShapeDataStylesOriginal,
  CardData as CardDataOriginal,
  Scaling as ScalingOriginal,
  ScalingWithLiterals as ScalingWithLiteralsOriginal,
  ImagePositionPosition as ImagePositionPositionOriginal,
  ImagePositionPositionWithLiterals as ImagePositionPositionWithLiteralsOriginal,
  CardDataBackgroundType as CardDataBackgroundTypeOriginal,
  CardDataBackgroundTypeWithLiterals as CardDataBackgroundTypeWithLiteralsOriginal,
  CardDataBackground as CardDataBackgroundOriginal,
  BackgroundImage as BackgroundImageOriginal,
  TocData as TocDataOriginal,
  ListStyle as ListStyleOriginal,
  ListStyleWithLiterals as ListStyleWithLiteralsOriginal,
  Indentation as IndentationOriginal,
  IndentationWithLiterals as IndentationWithLiteralsOriginal,
  SmartBlockData as SmartBlockDataOriginal,
  SmartBlockDataType as SmartBlockDataTypeOriginal,
  SmartBlockDataTypeWithLiterals as SmartBlockDataTypeWithLiteralsOriginal,
  ColumnSize as ColumnSizeOriginal,
  ColumnSizeWithLiterals as ColumnSizeWithLiteralsOriginal,
  SmartBlockCellData as SmartBlockCellDataOriginal,
  Metadata as MetadataOriginal,
  DocumentStyle as DocumentStyleOriginal,
  TextNodeStyle as TextNodeStyleOriginal,
  Badge as BadgeOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Empty as EmptyOriginal,
  EventDeleted as EventDeletedOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateRsvpApplicationErrors as CreateRsvpApplicationErrorsOriginal,
  UpdateRsvpApplicationErrors as UpdateRsvpApplicationErrorsOriginal,
  BulkUpdateRsvpsApplicationErrors as BulkUpdateRsvpsApplicationErrorsOriginal,
  BulkDeleteRsvpsByFilterApplicationErrors as BulkDeleteRsvpsByFilterApplicationErrorsOriginal,
  CheckInRsvpGuestsApplicationErrors as CheckInRsvpGuestsApplicationErrorsOriginal,
  CancelRsvpGuestsCheckInApplicationErrors as CancelRsvpGuestsCheckInApplicationErrorsOriginal,
  ListCurrentRsvpsApplicationErrors as ListCurrentRsvpsApplicationErrorsOriginal,
} from './events-v2-rsvp-rsvp-v-2.types.js';
